module.exports = __webpack_public_path__ + "img/gis.255c923c.svg";